import { useEffect } from 'react';

// Oživí odpočty v náhledu modalu. Element `.pf-cd` nese cílový čas v atributu
// title; stejnou logiku má SDK runtime, aby náhled odpovídal tomu, co uvidí
// uživatel na webu.
export function useModalCountdown(root: { current: HTMLElement | null }, deps: unknown[] = []): void {
  useEffect(() => {
    const host = root.current;
    if (!host) return;
    const els = host.querySelectorAll<HTMLElement>('.pf-cd');
    if (!els.length) return;
    const pad = (n: number) => (n < 10 ? '0' + n : String(n));
    const tick = () => {
      els.forEach((el) => {
        const end = Date.parse(el.getAttribute('title') ?? '');
        if (!end || Number.isNaN(end)) { el.textContent = ''; return; }
        const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        el.textContent = `${Math.floor(s / 3600)}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
      });
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
